export default __webpack_public_path__ + "static/media/sanrin.0845bf98.png";